import MobileHome from "@/components/app/home/home";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/home/")({
  component: MobileHome,
});
